import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import queryClient from './queryClient';
const ClientContext = React.createContext(undefined);
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useClient = () => {
    const client = React.useContext(ClientContext);
    if (!client) {
        throw new Error('You may have forgot to render <ClientProvider /> because client is not defined');
    }
    return client;
};
export const ClientProvider = ({ client, children }) => {
    return (React.createElement(QueryClientProvider
    // We are not talking about the same client
    , { 
        // We are not talking about the same client
        client: queryClient },
        React.createElement(ClientContext.Provider, { value: client }, children)));
};
export const TestClientProvider = ({ client, children }) => {
    return React.createElement(ClientContext.Provider, { value: client }, children);
};
